module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "categories"
  }, [(_vm.user.access > 5) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn green margin-right-5",
    on: {
      "click": function($event) {
        _vm.showAddCategoryModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Add category")]), _vm._v(" "), (_vm.currentCategory !== null) ? _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.showEditCategoryModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Edit current category")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn green margin-right-5 margin-bottom-20",
    class: {
      'btn-outline': _vm.currentCategory !== null
    },
    on: {
      "click": function($event) {
        return _vm.fetchCategory(null)
      }
    }
  }, [_vm._v("All Categories")]), _vm._l((_vm.alphabeticalOrderCategories), function(category) {
    return _c('button', {
      staticClass: "btn green margin-right-5 margin-bottom-20",
      class: {
        'btn-outline': !_vm.currentCategory || _vm.currentCategory.id !== category.id
      },
      on: {
        "click": function($event) {
          return _vm.fetchCategory(category.id)
        }
      }
    }, [_vm._v(_vm._s(category.title) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.user.access > 5 && !_vm.loading && _vm.currentCategory !== null) ? [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "example-btn"
  }, [_c('file-upload', {
    ref: "upload",
    staticClass: "btn green",
    attrs: {
      "post-action": _vm.uploadEndpoint,
      "data": {
        'categoryId': _vm.currentCategory.id
      },
      "multiple": true,
      "size": 1024 * 1024 * 100,
      "input-id": 'tutorial-upload-tutorial',
      "headers": {
        'token': _vm.token
      }
    },
    on: {
      "input-filter": _vm.inputFilter,
      "input-file": _vm.inputFile
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Select files\n            ")]), _vm._v(" "), (!_vm.$refs.upload || !_vm.$refs.upload.active) ? _c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Start Upload\n            ")]) : _c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Stop Upload\n            ")])], 1), _vm._v(" "), _c('ul', _vm._l((_vm.files), function(file, index) {
    return _c('li', {
      key: file.id
    }, [_c('span', [_vm._v(_vm._s(file.name))]), _vm._v(" -\n              "), _c('span', [_vm._v(_vm._s(file.size))]), _vm._v(" -\n              "), (file.error) ? _c('span', [_vm._v(_vm._s(file.error))]) : (file.success) ? _c('span', [_vm._v("success")]) : (file.active) ? _c('span', [_vm._v("active")]) : (file.active) ? _c('span', [_vm._v("active")]) : _c('span')])
  }), 0)]), _vm._v(" "), _c('hr')] : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('vue-spinner') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "tutorials"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.tutorials), function(tutorial) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-3 col-xs-4 tutorial-wrapper"
    }, [_c('div', {
      staticClass: "tutorial",
      style: ({
        'background-image': 'url(' + _vm.thumbUrl(tutorial.thumbFile) + ')'
      })
    }, [(!tutorial.thumbFile) ? _c('img', {
      staticClass: "placeholder",
      attrs: {
        "src": "/static/layouts/layout2/img/logo-default.png",
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_c('a', {
      staticClass: "btn green",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.playTutorial(_vm.getTutorialUrl(tutorial.file))
        }
      }
    }, [_vm._v("Play")]), _vm._v(" "), (_vm.user.access > 5) ? _c('button', {
      staticClass: "btn green",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.onTutorialSettingsClick(tutorial.id)
        }
      }
    }, [_vm._v("Settings")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "headers"
    }, [_c('h1', {
      staticClass: "tutorial-header"
    }, [_vm._v(_vm._s(tutorial.header))]), _vm._v(" "), _c('h2', {
      staticClass: "tutorial-subheader"
    }, [_vm._v(_vm._s(tutorial.subheader))])])])
  }), 0)]) : _vm._e()], 2)]), _vm._v(" "), (_vm.showAddCategoryModal) ? _c('add-category-modal', {
    on: {
      "display": function($event) {
        _vm.showAddCategoryModal = $event
      },
      "category-added": _vm.categoryAdded
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditCategoryModal && _vm.currentCategory !== null) ? _c('edit-category-modal', {
    attrs: {
      "id": _vm.currentCategory.id
    },
    on: {
      "display": function($event) {
        _vm.showEditCategoryModal = $event
      },
      "category-updated": _vm.categoryUpdated,
      "category-removed": _vm.categoryRemoved
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTutorialSettingsModal) ? _c('tutorial-settings-modal', {
    attrs: {
      "id": _vm.currentTutorialId,
      "categories": _vm.categories
    },
    on: {
      "display": function($event) {
        _vm.showTutorialSettingsModal = $event
      },
      "tutorial-updated": _vm.tutorialUpdated,
      "tutorial-removed": _vm.tutorialRemoved
    }
  }) : _vm._e(), _vm._v(" "), _c('video-tutorial-modal', {
    attrs: {
      "url": _vm.currentTutorialUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e47db7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpTutorials/HelpTutorialsIndex.vue
// module id = 1553
// module chunks = 1